var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizationsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14C10 18.4183 13.5817 22 18 22C22.4183 22 26 18.4183 26 14C26 9.58172 22.4183 6 18 6C13.5817 6 10 9.58172 10 14ZM30 22C30 25.3137 32.6863 28 36 28C39.3137 28 42 25.3137 42 22C42 18.6863 39.3137 16 36 16C32.6863 16 30 18.6863 30 22Z",
    fill: "#147D64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9667 26C8.52382 26 0.776517 30.853 0.00130337 40.3984C-0.0409235 40.9184 0.953424 42 1.455 42H34.4934C35.9958 42 36.0192 40.7909 35.9958 40.4C35.4098 30.5864 27.5424 26 17.9667 26ZM46.9119 42H39.2C39.2 37.4981 37.7126 33.3437 35.2024 30.0012C42.0154 30.0757 47.5784 33.5203 47.997 40.8C48.0139 41.0932 47.997 42 46.9119 42Z",
    fill: "#147D64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationsActive);
export default __webpack_public_path__ + "static/media/organizations-active.b66f75de876ef2e882f4cd20cfdad4bd.svg";
export { ForwardRef as ReactComponent };